import { visit } from 'unist-util-visit';
import { toText } from 'hast-util-to-text';
import type { Element, Root } from 'hast';
import type { VFile } from 'vfile';
import type { Heading } from '../../types';

const HEADINGS = new Set(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']);

declare module 'vfile' {
  interface DataMap {
    headings: Heading[];
  }
}

/**
 * Records every heading (in document order) on the vfile so the viewer can build
 * a table of contents without re-parsing or querying the DOM.
 *
 * Runs after `rehype-slug`, so every heading is guaranteed to have a stable id.
 */
export default function rehypeCollectHeadings() {
  return (tree: Root, file: VFile) => {
    const headings: Heading[] = [];

    visit(tree, 'element', (node: Element) => {
      if (!HEADINGS.has(node.tagName)) return;

      const id = typeof node.properties?.id === 'string' ? node.properties.id : '';
      const text = toText(node, { whitespace: 'normal' }).trim();
      if (!id || text === '') return;

      headings.push({ id, text, level: Number(node.tagName.slice(1)) });
    });

    file.data.headings = headings;
  };
}
